const round = (num, places = 1) => {
    return (Math.round(num * (10 ** places)) / (10 ** places)).toFixed(places);
};

export default round;
